<template>
  <div id="app">
    <router-view />
    <!-- 登录获取个人信息后触发应用登录埋点 -->
    <ns-track v-track.login="{ userInfo }" />
  </div>
</template>
<script>
import Event from '@/libs/Event';
import WaterMark from '@/libs/watermark';
import { mapGetters } from 'vuex';

export default {
  name: 'app',
  data() {
    return {};
  },
  created() {
    // 线上环境配置axios.defaults.baseURL，生产环境则用proxy代理
    if (process.env.NODE_ENV === 'development') {
      this.$store.commit('UPDATE_USER_FROM_LOCAL');
    }
    // 事件监听
    Event.on('app-load', (e) => {
      if (!e) return;
      // 只统计线上环境的事件
      if (!this.$config.isProduction) return;
    });
  },
  computed: {
    ...mapGetters(['userData', 'oauth']),
    userInfo() {
      return {
        userName: this.userData.username,
        email: this.userData.email,
        phoneNumber: this.userData.phone,
        // userId: this.userData.id,
        userId: this.userData.username,
        userNo: '',
        userType: '',
        clientId: '',
      };
    },
  },
  mounted() {
    window.addEventListener(
      'hashchange',
      () => {
        let currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
      },
      false
    );

    this.initWaterMarkData();
  },
  watch: {
    userData(val) {
      try {
        const { name = '', phone = '' } = val || {};
        WaterMark.set(`${name} ${phone}`, document.getElementById('app'));
      } catch (error) {
        window.console.log(error);
      }
    },
  },
  methods: {
    async initWaterMarkData() {
      // 如果没有登录
      if (this.oauth.access_token && !this.userData.id) {
        await this.$store.dispatch('getUserInfo');
      }
    },
  },
};
</script>
<style lang="scss">
html,
body {
  height: 100%;
  min-width: 1340px;
}

body{
  overflow-y: hidden;
}

#app {
  font-size: 14px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  height: 100%;
  background: #fff;
  color: #333;
}
</style>
